import React, {useState} from "react";
import {Colors, FontStyles, Routes as Route} from "../constants";
import {Flex} from "../common_style/flex";
import {Span} from "../common_style/text";
import styled from "styled-components";
import * as firebase from "firebase";
import {LANGUAGE} from '../../localizations/languages';
import {ReactComponent as Close} from "assets/icons/close_white.svg";
import {ReactComponent as Check} from "assets/icons/check_white.svg";
import {ReactComponent as Back} from "../../assets/icons/undo.svg";
import {Localization} from "localizations/languages";

const MenuLabel = styled(Span)`
  ${FontStyles.menuButton};
  width: 100%;
  line-height: 45px;
  text-align: center;
`;

const MenuLink = styled(Span)`
  ${FontStyles.menuButton};
  width: 100%;
  line-height: 45px;
  text-align: center;
  cursor: pointer;
  :hover {
    background-color: rgba(255,255,255,0.1);
  }
`;

function SideMenuView(props) {
    const [showLanguages, setShowLanguages] = useState(false);
    if (showLanguages) {
        return <Flex column hAlign vAlign style={{backgroundColor: Colors.primary, width: '100%', height: '100%'}}>
            <Flex hAlign={'space-between'}>
                <Flex vAlign={'center'} style={{cursor: 'pointer'}} onClick={() => setShowLanguages(false)}>
                    <Back style={{
                        width: '24x',
                        height: '24px',
                        margin: 40,
                        marginRight: 10
                    }}/><Span textStyle={FontStyles.menuButton}>{Localization.current.translation17}</Span></Flex>
                <Close onClick={() => {
                    props.closeMenu();
                    setShowLanguages(false);
                }} style={{
                    width: '24x',
                    height: '24px',
                    margin: 40,
                    cursor: 'pointer'
                }}/></Flex>
            <Flex column style={{marginTop: 100}}>
                <MenuLabel>{Localization.current.translation59}</MenuLabel>
                {Object.entries(LANGUAGE).map(([key, value]) => <MenuLink
                    onClick={() => {
                        props.onSetLanguage(value);
                    }}>{value.name}{value === Localization.getLanguage() ?
                    <Check style={{marginLeft: 9, marginRight: -27,  width: 18, height: 18}}/> : null}</MenuLink>)}
            </Flex>
        </Flex>
    }
    return <Flex column hAlign vAlign style={{backgroundColor: Colors.primary, width: '100%', height: '100%'}}>
        <Flex hAlign={'space-between'}><Close onClick={() => props.closeMenu()} style={{
            width: '24x',
            height: '24px',
            margin: 40,
            marginLeft: 'auto',
            cursor: 'pointer'
        }}/></Flex>
        <Span textStyle={FontStyles.titleLight}
              style={{textAlign: 'center'}}>{firebase.auth().currentUser.email.split('@')[0]}</Span>
        <Flex column style={{marginTop: 'auto', marginBottom: 'auto'}}>
            <MenuLink onClick={() => props.setRoute(Route.myStories)}>{Localization.current.translation4}</MenuLink>
            {/*<MenuLink onClick={() => props.setRoute(Route.findHelp)}>FIND HELP</MenuLink>*/}
            <MenuLink onClick={() => {
                window.open("https://www.youtube.com/watch?v=K6LoTCVV5TE", "_blank");
                props.closeMenu();
            }}>{Localization.current.translation5}</MenuLink>
            <MenuLink onClick={() => {
                window.open("http://micreate.eu", "_blank");
                props.closeMenu();
            }}>{Localization.current.translation6}</MenuLink>
            <MenuLink onClick={() => {
                setShowLanguages(true);
            }}>{Localization.current.translation59}</MenuLink>
        </Flex>
        <MenuLink style={{marginBottom: '40px'}} onClick={() => firebase.auth().signOut()}>{Localization.current.translation7}</MenuLink>
    </Flex>;
}

export default SideMenuView;
